import React from 'react';
import { LuClock9, LuSearch } from 'react-icons/lu';
import { Col, Row, VertTypography } from '@vertem-core/vertice-ds';
import PropTypes from 'prop-types';

import Icon from 'components/Atoms/Icons/Icon';
import CreateSearchHash from '../../Utils/createSearchHash';
import { Link } from 'react-router-dom';

const SearchAutocomplete = ({ ...props }) => {
  const { results, historyTerms, selectedIndex, term, onClick } = props;
  return (
    <div
      className="vert-autocomplete-box"
      aria-hidden
    >
      {historyTerms && historyTerms.length > 0 ? (
        <>
          <VertTypography.Paragraph className="history-title">
            Pesquisas recentes
          </VertTypography.Paragraph>
          <ul className="history-items">
            {historyTerms?.map((value) => (
              <li>
                <Row gutter={0}>
                  <Col className="col-auto">
                    <Icon
                      className="lucide txt-history-icon margin-right-small"
                      size="18px"
                      component={LuClock9}
                    />
                  </Col>
                  <Col className="col">
                    <Link
                      onClick={() => onClick()}
                      to={`/search/1/filter/${CreateSearchHash(
                        {},
                        { term: value }
                      )}`}
                      aria-hidden
                    >
                      {value}
                    </Link>
                  </Col>
                </Row>
              </li>
            ))}
          </ul>
        </>
      ) : (
        ''
      )}
      {results && results.length > 0 ? (
        <ul className="result-items">
          {results?.map((value, index) => {
            const classSelected =
              index === selectedIndex ? 'color-detached' : '';
            return (
              <li
                key={index}
                className={classSelected}
              >
                <Row gutter={0}>
                  <Col className="col-auto">
                    <Icon
                      className={`lucide txt-result-icon margin-right-small ${classSelected} `}
                      size="18px"
                      component={LuSearch}
                    />
                  </Col>
                  <Col className="col">
                    <Link
                      onClick={() => onClick()}
                      to={`/search/1/filter/${CreateSearchHash(
                        {},
                        { term, categories: value.id }
                      )}`}
                      aria-hidden
                      className={classSelected}
                    >
                      {`${term !== '' ? `${term} em ` : ''}${value.name}`}
                    </Link>
                  </Col>
                </Row>
              </li>
            );
          })}
        </ul>
      ) : (
        ''
      )}
    </div>
  );
};

SearchAutocomplete.propTypes = {
  results: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      count: PropTypes.number.isRequired,
    })
  ).isRequired,
  historyTerms: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedIndex: PropTypes.number,
  term: PropTypes.string,
  onClick: PropTypes.func
};


export default SearchAutocomplete;
